var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"fas fa-circle",class:`traffic-${_vm.color}`,attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }